export default __webpack_public_path__ + "static/media/brownhorse2.8c037167.jpg";